export const queryKeys = {
  // Profile
  GET_USER_PROFILE: "GET_USER_PROFILE",
  SURVEY_INFO: "SURVEY_INFO",
  PERSONALITY_SURVEY: "PERSONALITY_SURVEY",
  GET_JOBS: "GET_JOBS",
  GET_JOB: "GET_JOB",
  GET_SCORES: "GET_SCORES",
  SAVED_JOBS: "SAVED_JOBS",
  APPLIED_JOBS: "APPLIED_JOBS",
  REFRESH_TOKEN: "REFRESH_TOKEN",
};
